import { Box, Typography } from '@mui/material';
import { useDrawingArea } from '@mui/x-charts';
import { useTranslate } from 'react-admin';

export const LegendLabel = (props: { id: string; color: string; label: string; value: string }) => (
  <Box id={props.id} key={props.id} sx={{ display: 'flex' }}>
    <Box>
      <span
        style={{
          height: '10px',
          width: '10px',
          marginRight: '10px',
          marginTop: '10px',
          backgroundColor: props.color,
          borderRadius: '50%',
          display: 'inline-block',
        }}
      />
    </Box>
    <Box>
      <Typography>{props.label}</Typography>
      <Typography sx={{ fontWeight: 'bold' }}>{props.value}</Typography>
    </Box>
  </Box>
);

export const PieCenterLabel = (props: {
  total: string | number;
  label: string;
  width?: number;
  height?: number;
}) => {
  const { width: widthFromHook, height: heightFromHook, left, top } = useDrawingArea();
  const translate = useTranslate();
  const width = props.width ?? widthFromHook;
  const height = props.height ?? heightFromHook;

  return (
    <>
      <text
        x={left + width / 2}
        y={top + height / 2 - 10}
        style={{
          textAnchor: 'middle',
          dominantBaseline: 'central',
          fontSize: 15,
        }}>
        {translate(props.label)}
      </text>
      <text
        x={left + width / 2}
        y={top + height / 2 + 15}
        style={{
          textAnchor: 'middle',
          dominantBaseline: 'central',
          fontSize: 30,
          fontWeight: 'bold',
        }}>
        {props.total}
      </text>
    </>
  );
};

export type B2bCompanyDashboardProps = {
  useMock?: boolean;
  resource: 'b2b/companies' | 'companies';
};

export const getPctChange = (data: { value: number }[]) => {
  if (data.length < 2) {
    return 0;
  }

  const start = data.find((entry) => entry.value !== 0);
  if (!start || start.value === 0) {
    return 0;
  }
  const pct = ((data[data.length - 1].value - start.value) / start.value) * 100;
  return Math.round(pct * 100) / 100;
};
